module.exports = __webpack_public_path__ + "img/detail-wrap.0c9cc6dd.svg";